import { render } from "./Profile.vue?vue&type=template&id=4049cdb6&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=4049cdb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4049cdb6"]])

export default __exports__